import { LuSparkles } from "react-icons/lu";
import * as styled from "./FeatureBlock.styled"

function FeatureBlock({ list, title }) {
  return (
    <styled.Wrapper>
      <styled.Header>
        <styled.Badge>
          <LuSparkles size={14} /> Новинка
        </styled.Badge>
      </styled.Header>
      <styled.Title>{title}</styled.Title>
      <styled.List>
        {list.map(({ number, text }) => (
          <styled.Item key={number}>
            <styled.Number>{number}</styled.Number>
            <styled.Text>{text}</styled.Text>
          </styled.Item>
        ))}
      </styled.List>
    </styled.Wrapper>
  )
};

export default FeatureBlock;
